import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import AddOn from './AddOn';
import cx from 'classnames';
import isEmpty from 'lodash/isEmpty';
import logger from 'src/logger';
import Button from 'wonderbly-components/lib/Button';

import RichText from '../Prismic/RichText';
import { byAddonId } from './helpers';
import './addons.scss';
import Loading from '../Loading/Loading';

const AddOns = props => {
  // TODO: This should never happen. We're logging it and not rendering anything
  //   just in case it breaks the user journey. Once we understand what's up we
  //   will fix it.
  if (!props.activePage) {
    logger.error({
      message: 'Addons page loaded without an active page',
      product: props.productId,
      queryParams: props.queryParams
    });
    return null;
  }
  const hasLookInside = props.activePage.items.some(item => !isEmpty(item.lookInside));
  return (
    <section className="addons">
      <div className="container-guttered">
        <Fragment>
          <RichText fields={props.activePage.primary.content} className="addons-content" />
          <div className={cx('addon-items', {
            'addon-items--has-look-inside': hasLookInside
          })}>
            {props.activePage.items.map(item => {
              const component = props.values.components.find(byAddonId(item.id));
              return (
                <AddOn
                  {...item}
                  key={item.id}
                  value={item.id}
                  selected={!!component}
                  handleOnChange={props.updateComponents(item)}
                  large={props.activePage.items.length <= 2}
                  productCustomisation={props.productCustomisation}
                />
              );
            })}
          </div>
        </Fragment>
      </div>
      <div className="addons-actions">
        <div className="container-guttered">
          {props.activePage.primary.buttonBack && !props.isFirstPage &&
          <Button onClick={props.handleSubmit} className="addons-prev" outlined>{props.activePage.primary.buttonBack}</Button>
          }
          <Button
            onClick={props.handleSubmit}
            className="addons-next"
            colour="green"
            disabled={props.isSubmitting}
            raised>
            {props.isSubmitting
              ? <Loading xsmall relative />
              : props.activePage.primary.buttonCta
            }
          </Button>
        </div>
      </div>
    </section>
  );
};

AddOns.propTypes = {
  productId: PropTypes.string.isRequired,
  isSubmitting: PropTypes.bool.isRequired,
  isFirstPage: PropTypes.bool.isRequired,
  activePage: PropTypes.shape({
    primary: PropTypes.shape({
      content: PropTypes.array.isRequired,
      buttonCta: PropTypes.string.isRequired,
      buttonBack: PropTypes.string,
    }),
    items: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.string.isRequired,
    })).isRequired,
  }),
  values: PropTypes.shape({
    components: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.string.isRequired
    }))
  }).isRequired,
  productCustomisation: PropTypes.object.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  updateComponents: PropTypes.func.isRequired,
  queryParams: PropTypes.object,
};

export default AddOns;



// WEBPACK FOOTER //
// ./src/client/js/view/components/AddOns/AddOns.js